/**
 * Strip the query string from a URL while preserving path and hash.
 * Used in RUM `beforeSend` so identity / session params are not stored.
 */
export function stripQueryFromUrl(url: string): string {
    const queryIndex = url.indexOf('?');
    if (queryIndex === -1) {
        return url;
    }

    const hashIndex = url.indexOf('#');
    if (hashIndex > queryIndex) {
        return url.slice(0, queryIndex) + url.slice(hashIndex);
    }

    return url.slice(0, queryIndex);
}
